import React, { useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Route, Routes, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import PrcWrdTable from "./wordlist/PrcWrdTable";
import PrcWrdDetailDialog from "./wordlist/PrcWrdDetailDialog";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";

const mdTheme = createTheme();

const ASVRoute = () => {
  var loc = useLocation();
  console.log("loc", loc);

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "94vh",
          }}
        >
          <Container maxWidth="xl" sx={{ mt: 3, mb: 3 }}>
            <Paper>
              <Routes>
                <Route path="prcWrd" element={<PrcWrdTable />} />
                <Route path="prcWrd/:mgm_pk" element={<PrcWrdDetailDialog />} />
              </Routes>
            </Paper>
          </Container>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default ASVRoute;
